import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RockThumbnailService {
  private apiUrl = '/simulation-api/SegmentedRockFile';

  constructor(private httpClient: HttpClient) {}

  getThumbnail(fileName: string, fileType?: string): Observable<string | null> {
    if (!fileName) {
      return of(null);
    }

    const thumbnailUrl = `${this.apiUrl}/${fileName}/thumbnail`;
    let params = new HttpParams();
    if (fileType) {
      params = params.set('fileType', fileType);
    }

    return this.httpClient.get(thumbnailUrl, { responseType: 'blob', params }).pipe(
      map((blob: Blob) => {
        return URL.createObjectURL(blob);
      }),
      catchError((error: HttpErrorResponse) => {
        console.warn(`Thumbnail not available for ${fileName}:`, error.status);
        return of(null);
      })
    );
  }

  revokeThumbnailUrl(url: string | null): void {
    if (url && url.startsWith('blob:')) {
      URL.revokeObjectURL(url);
    }
  }
}
